import { render, staticRenderFns } from "./SaveQR.vue?vue&type=template&id=0706ddcc&scoped=true&"
import script from "./js/save-qr.js?vue&type=script&lang=js&"
export * from "./js/save-qr.js?vue&type=script&lang=js&"
import style0 from "./SaveQR.vue?vue&type=style&index=0&id=0706ddcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706ddcc",
  null
  
)

export default component.exports